// src/components/SearchModal/ItemModal.jsx
import { useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import FocusLock from "react-focus-lock";
import { CSSTransition } from "react-transition-group";

const ItemModal = ({ isOpen, onClose, children }) => {
 const nodeRef = useRef(null);
 const [previouslyFocusedElement, setPreviouslyFocusedElement] = useState(null);

 useEffect(() => {
  if (isOpen) {
   // モーダルを開く前のフォーカスされていた要素を保存
   setPreviouslyFocusedElement(document.activeElement);
   document.body.classList.add("is-noscroll");
   //    console.log("Modal opened, focus is on:", document.activeElement);
  } else {
   document.body.classList.remove("is-noscroll");
   //    console.log("Modal closed, focus is on:", document.activeElement);
  }

  return () => {
   document.body.classList.remove("is-noscroll");
  };
 }, [isOpen]);

 const handleClose = () => {
  onClose();
  //   console.log("Before focusing back, focus is on:", document.activeElement);
  if (previouslyFocusedElement) {
   // 保存していた要素にフォーカスを戻す
   previouslyFocusedElement.focus();
   //    console.log("Focus returned to:", previouslyFocusedElement);
  } else {
   document.body.focus();
  }
 };

 const modalContent = (
  <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={300} classNames="modal-transition" unmountOnExit mountOnEnter>
   <FocusLock returnFocus={false} disabled={!isOpen}>
    <div ref={nodeRef} className="p-item-modal p-item-modal--w100">
     <div className="p-item-modal__overlay p-item-modal__overlay--w100" onClick={handleClose}>
      <div className="p-item-modal__inner" onClick={(e) => e.stopPropagation()}>
       <div className="p-item-modal__container-wrap">
        <button tabIndex={0} className="p-item-modal__close-button" onClick={handleClose} aria-label="このダイアログウィンドウを閉じる">
         <span className="sr-only">このダイアログウィンドウを閉じる</span>
        </button>
        <div className="p-item-modal__body">{children}</div>
       </div>
      </div>
     </div>
    </div>
   </FocusLock>
  </CSSTransition>
 );

 return ReactDOM.createPortal(modalContent, document.getElementById("item_card_modal"));
};

export default ItemModal;
